import type { RouteRecordRaw } from 'vue-router'

const whatsappRoutes: RouteRecordRaw[] = [
  {
    path: '/whatsapp',
    name: 'WhatsApp',
    component: () => import('@/pages/whatsapp/WhatsappPage.vue'),
    meta: {
      requiresAuth: true,
      requiresWhatsAppCampaign: true,
      layout: 'DashboardLayout',
      title: 'common.titles.whatsapp',
    },
  },
]

export default whatsappRoutes
